<script lang="ts" setup>
import type { BookAppointment } from '@integration-layer/ampliance/schemas/book-appointment-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: BookAppointment
}>()

const data = await useComponentResponse<BookAppointment>(props)
</script>

<template>
  <ClientOnly>
    <BookAnAppointmentPage v-if="data" />
  </ClientOnly>
</template>
